import React from 'react';

import { useConfiguration } from '../../context/configurationContext';

import { getPuertoRicoMunicipalityName } from '../../util/puertoRicoMunicipalities';
import { Avatar } from '../../components';
import { LanguageBadge } from '../ProfilePage/ProfilePage';

import css from './ProfessionalDirectoryProfile.module.css';

const normalizeProfession = profession => (Array.isArray(profession) ? profession[0] : profession);
const websiteUrl = website =>
  website && /^https?:\/\//i.test(website) ? website : website ? `https://${website}` : null;

export const ProfessionalDirectoryIdentity = ({ provider, providerName, languages }) =>
  provider ? <div className={css.providerIdentity}>
    <Avatar user={provider} disableProfileLink className={css.providerAvatar} />
    <div><div className={css.providerName}>{providerName}</div><LanguageBadge languages={languages} className={css.providerLanguageBadge} /></div>
  </div> : null;

const ProfessionalDirectoryProfile = ({ title, description, publicData, provider, providerName, languages }) => {
  const config = useConfiguration();
  const professionId = normalizeProfession(publicData?.profession);
  const profession = config?.listing?.listingFields
    ?.find(field => field.key === 'profession')
    ?.enumOptions?.find(option => option.option === professionId)?.label || professionId;
  const municipalities = (publicData?.municipalityIds || [])
    .map(getPuertoRicoMunicipalityName)
    .filter(Boolean);
  const website = websiteUrl(publicData?.website);

  return (
    <div className={css.root}>
      <ProfessionalDirectoryIdentity provider={provider} providerName={providerName} languages={languages} />
      <header className={css.intro}>
        <h1 className={css.title}>{title}</h1>
        {profession ? <p className={css.profession}>{profession}</p> : null}
        {municipalities.length ? (
          <ul className={css.chips}>
            {municipalities.map(name => <li key={name}>{name}</li>)}
          </ul>
        ) : null}
      </header>
      {description ? <section><h2>Sobre mis servicios</h2><p className={css.description}>{description}</p></section> : null}
      {publicData?.phone || publicData?.email || website ? (
        <section className={css.contact}><h2>Información de contacto</h2>
          {publicData?.phone ? <p className={css.contactRow}><span>Teléfono</span><strong>{publicData.phone}</strong></p> : null}
          {publicData?.email ? <p className={css.contactRow}><span>Email</span><a href={`mailto:${publicData.email}`}>{publicData.email}</a></p> : null}
          {website ? <p className={css.contactRow}><span>Página web</span><a href={website} target="_blank" rel="noopener noreferrer">{publicData.website}</a></p> : null}
        </section>
      ) : null}
    </div>
  );
};

export default ProfessionalDirectoryProfile;
